<template>
    <div class="home">
        <header>
            <img src="@/assets/hotel/img/micon/back_tc.png" alt="back" @click="go('back')">
            <van-swipe class="swiper-box" @change="onChange">
                <van-swipe-item v-for="(item,index) of swiperList" :key="index" @click="goAdv(item)">
                    <img :src="item.img_url" alt="">
                </van-swipe-item>

                <template #indicator>
                    <ul class="indicator" v-if="swiperList.length>1">
                        <li :class="current-1==index&&'active'" v-for="(item,index) of swiperList" :key="index"></li>
                    </ul>
                </template>
            </van-swipe>
            <div class="bg-linear"></div>
        </header>
        <main>
            <div class="search-panel">
                <div class="logo">
                    <img src="@/assets/hotel/img/micon/logo.png" alt="logo">
                </div>
                <div class="position border-bottom">
                    <div @click="go('/hotel/city')">
                        <img src="@/assets/hotel/img/micon/search.png" alt="search">
                        <span>{{searchCity.name}}</span>
                    </div>
                    <div @click="rePosition">
                        <img src="@/assets/hotel/img/micon/aim.png" alt="aim">
                        <p>我的位置</p>
                    </div>
                </div>
                <div class="order-info border-bottom">
                    <div @click.stop="go('/hotel/checkin?timeSelect=1')">
                        <p :class="navTips[0].bool&&'active'">{{navTips[0].name}}</p>
                        <h3>{{getStartTime}}</h3>
                    </div>
                    <div @click.stop="go('/hotel/checkin?timeSelect=1')">
                        <span>{{ckeckinInfo.roomday}}晚</span>
                    </div>
                    <div @click.stop="go('/hotel/checkin?timeSelect=1')">
                        <p :class="navTips[1].bool&&'active'">{{navTips[1].name}}</p>
                        <h3>{{getEndTime}}</h3>
                    </div>
                    <div @click="go('/hotel/checkin?timeSelect=0')">
                        <p>人数/房间数</p>
                        <h3><span>{{ckeckinInfo.adultNum}}成人</span><span
                                :class="ckeckinInfo.childNum > 0 ? 'disable-actiate':  'disable'">{{ckeckinInfo.childNum}}儿童</span>
                        </h3>
                    </div>
                </div>
                <div class="search border-bottom" @click="go('/hotel/search')">
                    <input type="text" placeholder="试试搜: 位置/品牌/酒店名" r readonly :value="searchValue.name">
                    <div class="search-del" v-show="searchValue.name" @click.stop="delSearch">
                        <img src="@/assets/hotel/img/micon/search-clear.png" alt="">
                    </div>
                </div>
                <div class="search-btn">
                    <button @click="go('/hotel/choose')">查找酒店</button>
                </div>
            </div>
        </main>
        <footer>
            <Footer active='home'></Footer>
        </footer>
        <van-popup :overlay-style="{'background-color':'rgba(0,0,0,0.5)'}" v-model="popShow">
            <div class="pop-position">
                <h3>温馨提示</h3>
                <p>手机定位服务未开启，请前往设置，开启手机定位服务。</p>
                <div>
                    <div>知道了</div>
                    <div class="active">前往设置</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Footer from '@/pages/hotel/components/footer-nav.vue'
    import {
        getAdvData,
        getCityCode,
        restapiLongitudeLatitude
    } from '@/pages/hotel/api'
    import {
        mapState,
        mapMutations
    } from 'vuex'
    export default {
        components: {
            Footer
        },
        data() {
            return {
                isiOSX: false, //是不是iphonex机型以上
                longitude: '',
                latitude: '',
                popShow: false, //定位提示弹出框
                current: 1, //banner轮播图切换
                swiperList: [], //轮播图列表
                navTips: [{
                    name: '入住',
                    bool: false
                }, {
                    name: '退房',
                    bool: false
                }], //入退提示
            }
        },
        computed: {
            ...mapState({
                ckeckinInfo: state => state.hotel.ckeckinInfo,
                searchCity: state => state.hotel.searchCity,
                searchValue: state => state.hotel.searchValue,
                hoteldetail: (state) => state.hotel.hoteldetail
            }),
            getStartTime() { //获取起始时间
                let date = new Date(this.ckeckinInfo.start_timeDate);
                return `${date.getMonth()+1}月${date.getDate()}日`
            },
            getEndTime() { //获取结束时间
                let date = new Date(this.ckeckinInfo.end_timeDate);
                return `${date.getMonth()+1}月${date.getDate()}日`
            }
        },
        created() {
            //设置iphonex以上适配
            this.isiOSX = this.isIphoneX();
            sessionStorage.isiOSX = this.isiOSX;

            if (this.$route.query.token) {
                this.$api.setToken(this.$route.query.token);
            }

            let oScript = document.createElement('script');
            oScript.type = 'text/javascript';
            oScript.src =
                'https://webapi.amap.com/maps?v=1.4.15&key=b5a9f9375d4237110b977c24dae22e78&plugin=AMap.Geocoder';
            document.body.appendChild(oScript);
        },
        mounted() {
            document.documentElement.style.setProperty('font-size', document.body.clientWidth / 375 * 10 + 'px');
            // this.position()
            getAdvData().then((res) => {
                this.swiperList = res.shallBuy_HotelV2_index_banner;
            })
            if (!sessionStorage.getItem('coordinate')) {
                sessionStorage.setItem('coordinate', JSON.stringify({
                    longitude: 116.397072,
                    latitude: 39.909593
                }));
                let u = navigator.userAgent,
                    app = navigator.appVersion;
                let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器 
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端 
                if (isAndroid) {
                    window.setLocation = this.setLocation;
                    this.params('', '', "getLocation");
                }
                if (isiOS) {
                    dsBridge.call("getLocation", (positionObj) => {
                        this.setLocation(positionObj)
                    });
                }
            }
        },
        methods: {
            ...mapMutations(['setState']),
            onChange(index) {
                this.current = index + 1;
            },
            rePosition() { //重定位
                this.setState([{
                    name: 'searchCity',
                    value: {
                        name: '定位中...',
                        value: {},
                        bool: false
                    }
                }])
                let u = navigator.userAgent,
                    app = navigator.appVersion;
                let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器 
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端 
                if (isAndroid) {
                    window.setLocation = this.setLocation;
                    this.params('', '', "getLocation");
                }
                if (isiOS) {
                    dsBridge.call("getLocation", (positionObj) => {
                        this.setLocation(positionObj)
                    });
                }
            },
            go(path) { //跳转
             console.log('查找酒店')
                if (path == 'back') {
                    this.params('home', 'home', 'goBack')
                } else {
                     console.log('查找酒 店')
                    this.$router.push(path);
                }
            },
            setLocation(positionObj) {
                let obj = JSON.parse(positionObj);
                if (obj.longitude != '0') {
                    //设置app传来的经纬度
                    this.longitude = obj.longitude; //经度
                    this.latitude = obj.latitude; //纬度
                    sessionStorage.setItem('coordinate', JSON.stringify({
                        longitude: this.longitude,
                        latitude: this.latitude
                    }));
                    //逆向编码-经纬度转城市code
                    // window.onload=()=>{
                    this.position();
                    // }
                } else {
                    this.setState([{
                        name: 'searchCity',
                        value: {
                            name: '定位失败',
                            value: {},
                            bool: false
                        }
                    }])
                    this.hoteldetail.canTakeTaxi = false
                    this.setState([{
                        name: 'hoteldetail',
                        value: this.hoteldetail
                    }])
                }

            },
            position() {
                restapiLongitudeLatitude({
                    longitude: this.longitude,
                    latitude: this.latitude
                }).then(res => {
                    if (res.status === '1') {
                        let address = res.regeocode.addressComponent;
                        let obj = {};
                        let pname = (address.adcode).slice(0, 2);
                        let codeParams = {};
                        switch (pname) {
                            case '50':
                                ; //重庆
                            case '31':
                                ; //上海
                            case '11':
                                ; //北京
                            case '12':
                                codeParams = {
                                    "province": address.province.split('市')[0],
                                    "city": address.province.split('市')[0],
                                    "county": address.district.split('区')[0],
                                }
                                break; //天津
                            case '82':
                                ; //澳门
                            case '81': //香港
                                codeParams = {
                                    "province": address.province.split('特别行政区')[0],
                                    "city": address.province.split('特别行政区')[0],
                                    "county": address.district.split('区')[0],
                                }
                                break;
                            case '71':
                                ; //台湾
                                codeParams = {
                                    "province": address.province.split('省')[0],
                                    "city": address.province.split('省')[0],
                                    "county": address.province.split('省')[0],
                                }
                                break;
                            default:
                                codeParams = {
                                    "province": address.province.split('省')[0],
                                    "city": address.city.split('市')[0],
                                    "county": address.district.split('区')[0],
                                }
                        };
                        getCityCode(codeParams).then((res) => {
                            let name = `${codeParams.city}`;
                            this.setState([{
                                name: 'searchCity',
                                value: {
                                    name: name,
                                    value: {
                                        ...codeParams,
                                        name: name,
                                        code: res.code,
                                    },
                                    bool: true
                                }
                            }])
                        })
                        sessionStorage.position = JSON.stringify(obj);
                    } else {
                        this.setState([{
                            name: 'searchCity',
                            value: {
                                name: '定位失败',
                                value: {},
                                bool: false
                            }
                        }])
                        this.hoteldetail.canTakeTaxi = false
                        this.setState([{
                            name: 'hoteldetail',
                            value: this.hoteldetail
                        }])
                    }
                });
            },
            delSearch() { //删除已搜索
                this.setState([{
                    name: 'searchValue',
                    value: {}
                }])
            },
            goAdv(item) { //去广告链接
                console.log(item)
                let token = localStorage.getItem('_token');
                if (!token) {
                    throw new Error('未能获取到token')
                }
                switch (parseInt(item.advertising_type)) {
                    case 1:
                        ;
                    case 2:
                        ;
                    case 3:
                        if (item.href.startsWith('http')) {
                            window.location.href = `${item.href}?token=${token}`
                            return
                        }
                        if (item.href.startsWith('xblife')) {
                            const param = {
                            routePath: `${item.href}`
                            }
                            this.params(JSON.stringify(param), JSON.stringify(param), 'toOriginal')
                        }
                        break;
                    case 4:
                        let href = item.href
                        if (! /http.*:\/\/.+\?.+=.+/.test(href)) {
                            href = `${href}?token=${token}`
                        } else {
                            href = `${href}&token=${token}`
                        }
                        window.location.href = href
                        break;
                }
            },
            getQueryVariable(variable) { //获取token
                let query = window.location.search.substring(1);
                let vars = query.split("&");
                for (let i = 0; i < vars.length; i++) {
                    let pair = vars[i].split("=");
                    if (pair[0] == variable) {
                        return pair[1];
                    }
                }
                return false;
            },
        },
    }
</script>
<style>
  html {
    font-size: calc(var(--sizeScale2) * 10px);
  }
</style>
<style lang="less">
    // html {
    //     font-size: calc(var(--sizeScale2)*10px);
    //     -webkit-user-select: none;
    //     -moz-user-select: none;
    //     -ms-user-select: none;
    //     user-select: none;
    //     -webkit-touch-callout: none;
    // }
    // html, body{
    //     overflow-x: inherit;
    // }
    .home {
        min-height: 100vh;
        height: auto;
        background-color: #F5F6F7;

        header {
            height: 27rem;
            box-sizing: border-box;
            position: relative;

            img {
                width: 3.2rem;
                height: 3.2rem;
                position: absolute;
                top: 4.4rem;
                left: 2rem;
                z-index: 10;
            }

            .swiper-box {
                height: 100%;

                // background-color: red;
                img {
                    display: inline-block;
                    vertical-align: top;
                    border: 0;
                    width: 100%;
                    height: 100%;
                    position: relative;
                    top: 0;
                    left: 0;
                }
            }

            .indicator {
                display: flex;
                position: absolute;
                right: 5rem;
                top: 17.2rem;

                li {
                    width: 0.8rem;
                    height: 0.8rem;
                    border-radius: 50%;
                    background-color: rgba(245, 246, 247, 0.7);
                    margin-right: 0.5rem;
                    transition: 0.2s;

                    &:last-of-type {
                        margin: 0;
                    }

                    &.active {
                        width: 2rem;
                        height: 0.8rem;
                        border-radius: 0.55rem;
                        background-color: #108B30;
                    }
                }
            }

            .bg-linear {
                position: absolute;
                top: 22rem;
                left: 0;
                right: 0;
                height: 7.3rem;
                background: linear-gradient(0deg, #F5F6F7, rgba(136, 135, 127, 0.8), rgba(68, 68, 68, 0));
                z-index: 5;
            }
        }

        main {
            position: relative;

            .search-panel {
                position: absolute;
                top: -7.5rem;
                left: 50%;
                transform: translateX(-50%);
                width: 35.5rem;
                height: 32.9rem;
                border-radius: 2rem;
                background-color: #fff;
                padding: 2rem;
                box-sizing: border-box;
                color: #181818;
                z-index: 10;

                .logo {
                    font-size: 0;
                    margin-bottom: 1.4rem;

                    img {
                        width: 7rem;
                        height: 2.6rem;
                    }
                }

                .position {
                    display: flex;
                    justify-content: space-between;
                    font-size: 0;
                    padding-bottom: 1.2rem;

                    div:nth-of-type(1) {
                        display: inline-flex;
                        align-items: center;
                        width: 80%;

                        img {
                            width: 2rem;
                            height: 2rem;
                            margin-right: 1rem;
                        }

                        span {
                            font-size: 1.8rem;
                            font-weight: 500;
                            line-height: 2.5rem;
                        }
                    }

                    div:nth-of-type(2) {
                        text-align: center;

                        img {
                            width: 1.6rem;
                            height: 1.6rem;
                            margin-bottom: 0.2rem;
                        }

                        p {
                            font-size: 1rem;
                            font-weight: 400;
                            line-height: 1.4rem;
                        }
                    }
                }

                .order-info {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 1.5rem 0;

                    >div {
                        >p {
                            font-size: 1.2rem;
                            font-weight: 400;
                            color: #999999;
                            line-height: 1.7rem;
                            margin-bottom: 0.1rem;

                            &.active {
                                color: #F9591B;
                            }
                        }

                        >h3 {
                            margin: 0;
                            font-size: 1.7rem;
                            font-weight: 600;
                            line-height: 2.4rem;
                            color: #333333;

                            >span:nth-of-type(1) {
                                margin-right: 0.2rem;
                            }

                            >span.disable {
                                color: #AEAEAE;
                            }

                            >span.disable-actiate {
                                color: #333333;
                            }
                        }

                        >span {
                            display: inline-block;
                            width: 2.8rem;
                            height: 1.6rem;
                            text-align: center;
                            font-size: 1.1rem;
                            font-weight: 500;
                            line-height: 1.6rem;
                            color: #fff;
                            border-radius: 0.8rem;
                            background-color: #108B30;
                            vertical-align: middle;
                        }
                    }
                }

                .search {
                    padding: 1.5rem 0;
                    margin-bottom: 2rem;

                    input {
                        height: 2.5rem;
                        width: 80%;
                        border: none;
                        font-size: 1.8rem;

                        &::-webkit-input-placeholder {
                            font-size: 1.8rem;
                            font-weight: 500;
                            color: #CCCCCC;
                            line-height: 2.5rem;
                        }
                    }

                    .search-del {
                        position: absolute;
                        top: 50%;
                        right: 1rem;
                        transform: translateY(-50%);
                        z-index: 10;
                        width: 4.4rem;
                        height: 4.4rem;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                            width: 1.6rem;
                            height: 1.6rem;
                        }
                    }
                }

                .search-btn {
                    button {
                        width: 100%;
                        height: 4.5rem;
                        border-radius: 2.25rem;
                        background-color: #108B30;
                        color: #fff;
                        font-size: 1.8rem;
                        line-height: 2.5rem;
                        font-weight: 500;
                        border: none;
                    }
                }
            }

            .border-bottom {
                position: relative;

                &::after {
                    content: "";
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 0.1rem;
                    background-color: #DDDDDD;
                    -webkit-transform: scaleY(.5);
                    transform: scaleY(.5);
                }
            }
        }

        footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 999;
        }

        .van-popup {
            background-color: transparent;
        }

        .pop-position {
            width: 31.5rem;
            height: 21.9rem;
            background-color: #fff;
            border-radius: 2rem;
            padding: 2rem;
            box-sizing: border-box;

            h3 {
                margin: 0;
                font-size: 1.8rem;
                font-weight: 500;
                color: #181818;
                line-height: 2.5rem;
                text-align: center;
                margin-bottom: 1.8rem;
            }

            p {
                font-size: 1.6rem;
                font-weight: 400;
                color: #333333;
                line-height: 2.8rem;
                margin-bottom: 3rem;
            }

            >div {
                display: flex;
                justify-content: space-between;

                div {
                    width: 12.7rem;
                    height: 5rem;
                    background-color: #E9E9E9;
                    border-radius: 1rem;
                    font-size: 1.8rem;
                    line-height: 5rem;
                    color: #333333;
                    text-align: center;

                    &.active {
                        background-color: #108B30;
                        color: #fff;
                    }
                }
            }
        }
    }
</style>